import { call, select, put, takeLatest } from 'redux-saga/effects';
import * as actions from '../actions';
import { ADD_CAR_ELIGIBILITY_REQUEST } from '../types';
import { addCarEligibilityApi } from '../api';
import { ELIGIBILITY_ERROR_TYPE } from '../reducers/addCar/addCarEligibility';

export function* addCarEligibilityRequestSaga() {
  try {
    const {
      root: {
        addCar: {
          vinCheck: { vin, captcha },
        },
      },
      Data: { csrfToken, reCaptchaSiteKey },
    } = yield select();

    const actionName = 'addCarEligibility';
    const recaptchaToken = reCaptchaSiteKey
      ? yield window.grecaptcha.execute(reCaptchaSiteKey, {
          action: actionName,
        })
      : '';

    const payload = {
      vin: vin.toUpperCase(),
      captcha,
      recaptchaToken: { actionName, tokenId: recaptchaToken },
    };

    const {
      data: {
        success,
        message,
        data: { carName, CarName },
      },
    } = yield call(addCarEligibilityApi, csrfToken, payload);
    const name = carName || CarName; // will be using carName only after migration to Apollo service is done
    if (!success && message === 'invalid svgCaptcha') {
      yield put(actions.addCarEligibilityFailure(ELIGIBILITY_ERROR_TYPE.INVALID_CAPTCHA));
    } else if (!name) {
      yield put(actions.addCarEligibilityFailure(ELIGIBILITY_ERROR_TYPE.INELIGIBILITY));
    } else {
      yield put(actions.addCarEligibilitySuccess(name));
    }
  } catch (e) {
    yield put(actions.addCarEligibilityFailure(ELIGIBILITY_ERROR_TYPE.INELIGIBILITY));
  }
}

const addCarEligibilitySaga = [
  takeLatest(ADD_CAR_ELIGIBILITY_REQUEST, addCarEligibilityRequestSaga),
];

export default addCarEligibilitySaga;
